import React, { Component } from "react";
import { Form, Button, InputGroup } from 'react-bootstrap';
import APIService from "../services/APIService";
import { pageReady } from "../services/UtilityService";

class PitImages extends Component {
    constructor(props) {
        super(props);
        this.state = {
            image: null,
            uploading: false,
            teamNumber: "",
            response: null,
            searchTeamNumber: '',
            fetchedImage: null,
        };
    }

    componentDidMount() {
        pageReady();
        localStorage.setItem("adminMode", false);
    }

    handleImageChange = (e) => {
        this.setState({ image: e.target.files[0] });
    };

    handleTeamNumberChange = (e) => {
        this.setState({ teamNumber: e.target.value });
    };

    handleSearchTeamNumberChange = (e) => {
        this.setState({ searchTeamNumber: e.target.value });
    };

    convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    resizeImage = async (base64Image, maxDimension) => {
        return new Promise((resolve) => {
            const img = new Image();
            img.src = base64Image;

            img.onload = () => {
                let width = img.width;
                let height = img.height;
                if (width > height && width > maxDimension) {
                    height = (height * maxDimension) / width;
                    width = maxDimension;
                } else if (height > width && height > maxDimension) {
                    width = (width * maxDimension) / height;
                    height = maxDimension;
                }

                const canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;

                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, width, height);

                const resizedImage = canvas.toDataURL();
                resolve(resizedImage);
            };
        });
    };


    handleSubmit = async (e) => {
        e.preventDefault();

        const { image, teamNumber } = this.state;

        if (!image) {
            alert("Please select an image to upload.");
            return;
        }

        if (!teamNumber) {
            alert("Please enter a team number.");
            return;
        }

        const base64Image = await this.convertToBase64(image);
        let resizedImage = await this.resizeImage(base64Image, 500);
        // Start string after the comma
        resizedImage = resizedImage.substring(resizedImage.indexOf(",") + 1);
        const data = {
            image: resizedImage,
            teamNumber: teamNumber,
        };

        let instanceId = localStorage.getItem("instanceId");
        let event = localStorage.getItem("event");

        try {
            this.setState({ uploading: true });
            let currentState = this;
            APIService.post("METRIC", `${instanceId}/${teamNumber}/${event}/picture`, data)
                .then((response) => {
                    console.log(response);
                    alert("Image uploaded successfully!");
                    window.location.reload(true);
                })
                .catch(function (error) {
                    APIService.error(error);
                    currentState.setState({ uploading: false });
                });
        } catch (error) {
            alert("Error uploading image. Please try again.");
            console.log(error);
        }
    };

    fetchImageByTeamNumber = async () => {
        const { searchTeamNumber } = this.state;
        let instanceId = localStorage.getItem("instanceId");
        let event = localStorage.getItem("event");

        try {
            APIService.get("METRIC", `${instanceId}/${searchTeamNumber}/${event}/picture`)
                .then((response) => {
                    console.log(response);
                    this.setState({ fetchedImage: response.data.image });
                })
                .catch(function (error) {
                    APIService.error(error);
                });
        } catch (error) {
            console.error('Error fetching image:', error);
        }
    };

    render() {
        const { uploading, response, fetchedImage } = this.state;

        return (
            <div>
                <h1>Upload an Image</h1>
                <form onSubmit={this.handleSubmit}>
                    <InputGroup className="mb-3">
                        <InputGroup.Text id="basic-addon1">Team Number</InputGroup.Text>
                        <Form.Control id="Team Number" aria-label="Team Number" type="number" placeholder="Team Number" onChange={this.handleTeamNumberChange} />
                    </InputGroup>
                    <Form.Group controlId="formFile" className="mb-3">
                        <Form.Control type="file" accept="image/*" onChange={this.handleImageChange} />
                    </Form.Group>
                    <Button variant="primary" type="submit" disabled={uploading}>
                        {uploading ? "Uploading..." : "Upload"}
                    </Button>
                </form>
                {response && (
                    <div>
                        <h2>Upload Response</h2>
                        <pre>{JSON.stringify(response, null, 2)}</pre>
                    </div>
                )}
                <h1>Search for Image by Team Number</h1>
                <InputGroup className="mb-3">
                    <InputGroup.Text id="basic-addon1">Team Number</InputGroup.Text>
                    <Form.Control type="number"
                        id="searchTeamNumber"
                        min="1"
                        onChange={this.handleSearchTeamNumberChange}
                        placeholder="Team Number" />
                    <Button variant="primary" onClick={this.fetchImageByTeamNumber}>Search</Button>
                </InputGroup>
                {fetchedImage && (
                    <div>
                        <h2>Image Found</h2>
                        <img src={"data:image/jpeg;base64," + fetchedImage} alt="Fetched by Team Number" style={{ width: '100%', height: 'auto' }}/>
                    </div>
                )}
            </div>
        );
    }
}

export default PitImages;
